import { Gift } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export const readRefInfo = () => {
  try {
    const r = JSON.parse(localStorage.getItem("clipx_ref") || "null");
    return r && Date.now() - r.at < 30 * 864e5 ? r : null;
  } catch { return null; }
};

export const RefBanner = () => {
  const { t } = useI18n();
  const r = readRefInfo();
  if (!r) return null;
  return (
    <div className="mb-6 rounded-xl border border-[#22e3a1]/40 bg-[#22e3a1]/10 px-4 py-3 flex items-center gap-3 cx-rise" data-testid="register-ref-banner">
      <Gift className="w-5 h-5 text-[#22e3a1] shrink-0" />
      <div className="text-sm">
        <div className="text-white font-semibold">{r.name ? t("ref.invited_by").replace("{name}", r.name) : t("ref.invited")}</div>
        <div className="text-[#22e3a1] text-xs">{t("ref.banner_bonus").replace("{n}", r.bonus || 3)}</div>
      </div>
    </div>
  );
};
